import { Typography, Grid } from '@mui/material';

import { Icon } from 'components/Icon';

import { INotificationColor } from './NotificationItem';

interface LinkTextAndIconProps {
  linkText: string;
  color: INotificationColor;
  iconColor: string;
}

const LinkTextAndIcon = ({
  linkText,
  color,
  iconColor
}: LinkTextAndIconProps) => (
  <Grid
    size={{ xs: 2, lg: 3 }}
    container
    sx={{
      wrap: 'nowrap',
      justifyContent: 'flex-end'
    }}
  >
    <Grid>
      <Typography
        variant="subtitle1"
        sx={{ display: 'inline', color: `${color}.main` }}
      >
        {linkText}
      </Typography>
    </Grid>
    <Grid>
      <Icon
        icon="chevronRight"
        fontSize="small"
        sx={{
          marginLeft: '10px',
          color: iconColor,
          verticalAlign: 'middle'
        }}
      />
    </Grid>
  </Grid>
);

export default LinkTextAndIcon;
